const updateFormControls = ({
  variant,
  variantsData,
  optionNames,
  selectedOptions,
  atcButton
}) => {
  if (!atcButton) return;

  const allOptionsSelected = variantsData.length === 1 || optionNames.every(name => selectedOptions[name]);

  if (variant && variant.available && allOptionsSelected) {
    atcButton.disabled = false;
  } else {
    atcButton.disabled = true;
  }
};

export default updateFormControls;
